export const COUNTRY_ID_MAPPING = {
  USA_COUNTRY_ID: 1,
  CANADA_COUNTRY_ID: 2,
};
